export { default } from "./ContentSettingsAdvisory";
